module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/超大广角3.af54693b.png";